import { render, staticRenderFns } from "./IVRCalls.vue?vue&type=template&id=2705b83d&"
import script from "./IVRCalls.vue?vue&type=script&lang=js&"
export * from "./IVRCalls.vue?vue&type=script&lang=js&"
import style0 from "./IVRCalls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports